// do not use for circular objects or non JSON objects
export const simpleDeepClone = <T>(o: T): T => {
  if (!o) return o
  return JSON.parse(JSON.stringify(o))
}
